import { render } from "./FacultyComplianceCheckedDetails.vue?vue&type=template&id=31becf29"
import script from "./FacultyComplianceCheckedDetails.vue?vue&type=script&lang=js"
export * from "./FacultyComplianceCheckedDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__